import { render, staticRenderFns } from "./Reply3.vue?vue&type=template&id=c9767890&scoped=true"
import script from "./Reply3.vue?vue&type=script&lang=js"
export * from "./Reply3.vue?vue&type=script&lang=js"
import style0 from "./Reply3.vue?vue&type=style&index=0&id=c9767890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9767890",
  null
  
)

export default component.exports